/**
 * Lightweight Web Audio beep — no asset files required.
 * Uses the browser AudioContext to synthesize a short chime.
 *
 * Respects the user's "alerts muted" preference (localStorage key).
 */

const STORAGE_KEY = 'dispatch_alerts_muted';

let ctx = null;
function getCtx() {
  if (!ctx) {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    ctx = new Ctor();
  }
  return ctx;
}

export function isAlertsMuted() {
  return localStorage.getItem(STORAGE_KEY) === '1';
}

export function setAlertsMuted(muted) {
  if (muted) localStorage.setItem(STORAGE_KEY, '1');
  else localStorage.removeItem(STORAGE_KEY);
}

/**
 * Play a short 2-tone beep for new orders. Falls back silently if audio
 * is blocked (e.g., autoplay policy before user interaction).
 */
export function playNewOrderBeep() {
  if (isAlertsMuted()) return;
  const audio = getCtx();
  if (!audio) return;
  try {
    if (audio.state === 'suspended') audio.resume();
    const now = audio.currentTime;

    // First tone: 880 Hz for 120ms
    const o1 = audio.createOscillator();
    const g1 = audio.createGain();
    o1.type = 'sine';
    o1.frequency.value = 880;
    g1.gain.setValueAtTime(0, now);
    g1.gain.linearRampToValueAtTime(0.15, now + 0.01);
    g1.gain.linearRampToValueAtTime(0, now + 0.12);
    o1.connect(g1).connect(audio.destination);
    o1.start(now);
    o1.stop(now + 0.15);

    // Second tone: 1320 Hz for 120ms, 80ms after first
    const o2 = audio.createOscillator();
    const g2 = audio.createGain();
    o2.type = 'sine';
    o2.frequency.value = 1320;
    g2.gain.setValueAtTime(0, now + 0.2);
    g2.gain.linearRampToValueAtTime(0.15, now + 0.21);
    g2.gain.linearRampToValueAtTime(0, now + 0.34);
    o2.connect(g2).connect(audio.destination);
    o2.start(now + 0.2);
    o2.stop(now + 0.36);
  } catch (e) {
    // ignore — audio context errors shouldn't break the UI
  }
}
